// FileReader rather than Blob.text(): it works in every environment, jsdom included.
const readText = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });

// A request made for a file (responseType "blob") receives its error body as a Blob as
// well, so the server's { "message": ... } has to be read out of it before it can be shown.
export const blobErrorMessage = async (data) => {
  if (!(data instanceof Blob) || !String(data.type).includes("json")) return null;
  try {
    const { message } = JSON.parse(await readText(data));
    return message || null;
  } catch (error) {
    return null;
  }
};
